import React from "react";
import { Col } from "reactstrap";
import { DebounceInput } from "react-debounce-input";
import { toast } from "react-toastify";
import { useSpecificationContextState } from "./useSpecificationContextState";
import { useSpecificationContextUpdater } from "./useSpecificationContextUpdater";

export default function NumberFormatWrapper({
   onChangeString,
   readOnlyPRP,
   allowZeroPRP = true,
   useBlur = false,
   roundTo = 2
}) {
   const SpecContextState = useSpecificationContextState();
   const SpecUpdater = useSpecificationContextUpdater();

   let value = SpecContextState.specification[onChangeString];
   const readOnly = (readOnlyPRP === null || readOnlyPRP === undefined) ? false : !readOnlyPRP;
   if (onChangeString === "numEnds") value = value < 1 ? 1 : value;

   const onChangeRegexFormat = (paragraph, propertyName) => {
      // if (typeof paragraph != "string" || paragraph === "") return 0;
      const regex = /[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)/;
      const found = paragraph.match(regex);
      if (found != null || paragraph === "") {
         let value;
         if (paragraph === "") {
            value = null;
         } else {
            value = parseFloat(found[0]);
            if (value && (value % 1 !== 0)) {               
               value = parseFloat(value?.toFixed(roundTo)); // parse it again because toFixed returns a string
            }
         }
         SpecUpdater.onChange(propertyName, value);
      } else {
         toast.warning(`your number ${paragraph} is not formatted correctly please try again`);
      }
   };

   var doNothing = () => { };

   return (
      <Col xs="2">
         <DebounceInput
            key={onChangeString}
            element={"input"}
            className={"form-control"}
            value={!allowZeroPRP && !value && readOnly ? "N/A" : value}
            onChange={(e) => useBlur ? doNothing() : onChangeRegexFormat(e.target.value, onChangeString)}
            onBlur={(e) => useBlur ? onChangeRegexFormat(e.target.value, onChangeString) : doNothing()}
            readOnly={readOnly}
            debounceTimeout={350}
            disabled={readOnly}
            placeholder={"N/A"}
         />
      </Col>
   );
}
